module.exports = __webpack_public_path__ + "img/shop.efb0dc8c.svg";